
import {windVane, aligenie} from "../../utils/tmallGenius";
import Group from 'vux/src/components/group/index.vue'
import CellBox from 'vux/src/components/cell-box/index.vue'
import Cell from 'vux/src/components/cell/index.vue'

import {unbindDevice, deleteSubDevice, getDevInfo} from "../../api/index";
import Selection from "./Index_selection/index.vue";
import {findSupportConnectDevice} from "../../utils/device/deviceConnect";
import {showDevice} from "../../utils/device/deviceShow";
import {kookongDeviceType} from "../../utils/device/set/remote";
import {getPlugName, isCanChangeNameDevice} from "../../utils/device/deviceName";
export default {
components: {CellBox, Group, Cell, Selection},
data() {
return {
setting: {}, //从设备大类中选一个
data: {}, //当前设备,
deviceInfo: {},
selectionComponent: "", //选框显示的组件
supportedFunction: { //支持的选项
changeSocket: false,
changeName: false,
changeRoom: true,
changeChannel: false,
},
};
},
beforeRouteEnter(to, from, next) {
windVane.setNavTitle("设置");
next();
},
/*------------------------------------------- 开始运行 -------------------------------------------------------*/
created() {
this.getPlugName = getPlugName;
this.getData();
},
methods: {
/*------------------------------------------- 自定义函数 -------------------------------------------------------*/
/*  获取房间名字
* */
getRoomName(aligenieZone, roomName) {
return aligenie.getRoomName(aligenieZone, roomName);
},
/*  更换遥控点击
* */
changeRemoteClick() {
const router = {
1: "/device/tvbox",
2: "/device/tv",
8: "/device/fan",
4: "/device/air",
};
this.$router.push({
path: router[this.$route.query.kookongDeviceType],
query: {
bid: this.$route.query.bid,
kookongDeviceType: this.$route.query.kookongDeviceType,
uid: this.$route.query.uid,
deviceId: this.$route.query.deviceId,
deviceType: this.$route.query.deviceType
}
});
},
/*  完成点击
* */
finishClick() {
windVane.exitApp();
},
/*  删除按钮点击
* */
deleteClick() {
const self = this;
this.$vux.confirm.show({
title: "提示",
content: self.setting.alert,
/*  确认点击
* */
onConfirm() {
self.setting.deleteFunction(self).then(res => {
if (res.status === 0) {
self.toast_success();
setTimeout(() => {
let back = -1;
const extraBackGo = self.$route.query.extraBackGo || 0; //如果是内页，要回到首页要多跳一次
self.$router.go(back - extraBackGo); //回到首页，无历史记录
}, 500);
} else {
self.toast_fail();
}
});
}
});
},
/*  获取设备信息
* */
getData() {
return new Promise(resolve => {
getDevInfo({
token: sessionStorage.getItem("token"),
deviceId: this.$route.query.deviceId
}).then(res => {
if (res.status === 0) {
this.data = res.data;
this.deviceInfo = findSupportConnectDevice(res.data);
this.deviceTypeName = showDevice.getDeviceTypeName(this.data.deviceType);
this.chooseSetting();
resolve();
}
});
});
},
/*  选择页面配置
* */
chooseSetting() {
let deviceInfo = this.deviceInfo;

if (this.data.gdid === 1) {  //入网类：解绑
this.setting.deleteFunction = function (_this) {
return unbindDevice({

token: sessionStorage.getItem("token"),
uid: _this.$route.query.uid
});
};
} else if (this.data.gdid === 2) {  //普通设备：删除
this.setting.deleteFunction = function (_this) {
return deleteSubDevice({
token: sessionStorage.getItem("token"),
deviceId: _this.$route.query.deviceId
});
}
} else { // 其他设备：不能删除
this.setting.deleteFunction = null;
}
if (deviceInfo && deviceInfo.functionType === 'controller') {
this.setting.alert = '设备删除后，该设备的所有遥控器也将被删除。';
} else {
this.setting.alert = '删除此设备，将无法再进行远程控制';
}

this.supportedFunction = {
changeSocket: this.deviceTypeName === 'socket' || this.deviceTypeName === 'switch',
changeName: isCanChangeNameDevice(this.data.deviceType) ? true : false,
changeRoom: true, //都支持
changeChannel: deviceInfo &&
(deviceInfo.kookongDeviceType === kookongDeviceType.TV || deviceInfo.kookongDeviceType === kookongDeviceType.TV_BOX),
};
},
/*------------------------------------------- 绑定函数 -------------------------------------------------------*/
/**  各种选框选项显示
* @param type{string}操作的类型
*  @param defaultValue 默认选择的数据
*/
showSelectClick(type, defaultValue) {
this.$refs["selection"].showSelection(type, defaultValue); //传给选择组件
},

/**
* 选择改变
* @param type{string}返回的操作的类型
*/
selectionChange(type) {
this.getData().then(() => {
if (type === "plug") {
setTimeout(() => {
this.showSelectClick('deviceName', this.data.aligenieName || this.data.deviceName);
}, 500);
}
});
}
}
};



// WEBPACK FOOTER //
// ./src/pages/settings/Index.vue